import React from "react";

import { ReactComponent } from "../../../assets/images/staffi-small-logo.svg";

const UBlack = ({ ...props }) => {
  return <ReactComponent {...props} />;
};

export default UBlack;
